<template>
  <div class="landing-page">
    <div class="header">
      <div class="text">{{ $t('header') }}</div>
      <img class="logo" src="@/assets/image/activity/header-logo.png">
    </div>
    <div v-if="!verified" class="verify">
      <div class="banner">
        <img v-if="bannerImageUrl" :src="bannerImageUrl" class="banner-image">
      </div>
      <div class="content">
        <auth-form class="form-container" @showPassDialog="showPassDialog"></auth-form>
        <static-resource v-if="step === 'inputMobile'" class="static"></static-resource>
      </div>
      <md-dialog
        class="pass-dialog"
        :title="$t('forgotPassword')"
        :closable="true"
        v-model="displayForgetPass"
      >
        <forget-pass @done="hidePassDialog"></forget-pass>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import AuthForm from '@/components/activity/AuthForm'
import ForgetPass from '@/components/activity/ForgetPass'
import StaticResource from '@/components/activity/StaticResource'

const Cookie = require('js-cookie')

export default {
  i18n: {
    messages: {
      en: {
        header: 'Officially registered at',
        forgotPassword: 'Reset Password',
      },
      id: {
        header: 'Resmi Terdaftar di',
        forgotPassword: 'Atur ulang kata sandi',
      },
    },
  },
  components: {
    [Dialog.name]: Dialog,
    AuthForm,
    ForgetPass,
    StaticResource,
  },
  data() {
    return {
      displayForgetPass: false,
      bannerImageUrl: '',
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    channel() {
      return this.$route.params.channel
    },
    step() {
      return this.$route.query.step || 'inputMobile'
    },
    verified() {
      return this.$route.query.verified || false
    },
  },
  mounted() {
    // save channel
    const { channel } = this.$route.params
    if (channel) {
      Cookie.set('channel', channel)
    }
    const lang = this.$route.query.lang
    if (lang) {
      this.$store.commit('updateLocale', lang)
      window.vue.$i18n.locale = lang
    }
    this.$store.commit('updateInviteCode', this.$route.query.inviteCode || '')
    this.getBannerImageUrl()
  },
  methods: {
    showPassDialog() {
      this.displayForgetPass = true
    },
    hidePassDialog() {
      this.displayForgetPass = false
    },
    async getBannerImageUrl() {
      if (!this.channel) {
        this.bannerImageUrl = require(`@/assets/image/activity/banner-${this.locale}.png`)
        return
      }
      try {
        const channelRes = await this.$http.get(`/marketing/channel?code=${this.channel}`)
        const data = channelRes.data.data
        this.bannerImageUrl = data && data.mobileBannerFgImg ? data.mobileBannerFgImg[this.locale] : ''
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.landing-page {
  background: #f8f8f8;
  width: 100%;
  margin: 0;
}

.landing-page.content {
  top: 0;
}

.header {
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  .text {
    font-size: 14px;
    line-height: 16px;
    color: #888;
    margin-right: 10px;
  }
  .logo {
    width: 220px;
    height: 32px;
  }
}

.verify {
  background: color-primary;
  .banner {
    height: 220px;
    .banner-image {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    min-height: calc(var(--vh, 1vh) * 100 - 4.12rem);
    padding: 0 20px 0;
    .form-container {
      position: relative;
      background: #ffffff;
      margin-bottom: 35px;
      padding: 30px 16px;
      border-radius: 6px;
    }
    .static {
      margin: 0 -20px;
    }
  }
}

.pass-dialog /deep/ {
  .md-popup-box {
    width: 90%;
    border-radius: 8px;
  }
  .md-dialog-content {
    width: 100%;
  }
  .md-dialog-title {
    font-size: 16px;
  }
  .md-dialog-body {
    padding: 30px 10px;
    display: block;
  }
}

</style>
